export enum RegistrationFlowScreen {
  AUTH = 'AUTH',
  FORM = 'FORM',
  ACTIVATE = 'ACTIVATE',
  PERSONAL = 'PERSONAL',
  RECEIPT = 'RECEIPT',
}
